export const loadScript = (src = '', whitelisted = false) => {
  let element;

  if(!src) {
    console.warn('loadScript - no src defined');
  }

  if(whitelisted) {
    element = document.createElement('script');
    element.type = 'text/javascript';
    element.src = src;
  } else {
    element = document.createElement('iframe');
    element.setAttribute('sandbox', 'allow-scripts');
    element.style.opacity = 0;
    element.srcdoc =
      `<html>
        <head>
          <script src=${src} type="text/javascript"></script>
        </head>
        <body>
        </body>
       </html>`;
  }

  return element;
};


// WEBPACK FOOTER //
// ./src/Services/Misc/loaders.js